import React, { FC, useEffect, useState } from "react";
import { ArrowPrev } from "../Icon/icons/ArrowPrev";
import ModalAnimation from "../ModalAnimation/ModalAnimation";
import { Video } from "../Video";
import ModalBigPicture from "./ModalBigPicture";
import { Image } from "@components/ui/Image";
import { IGalleryItemProps } from ".";

interface IModalProps {
  gallery: IGalleryItemProps[];
  onRequestClose: () => void;
  visible: boolean;
}

const ModalAllImages: FC<IModalProps> = ({
  gallery,
  onRequestClose,
  visible,
}) => {
  const [currentImageCarroseulIndex, setCurrentImageCarroseulIndex] =
    useState(-1);
  const [modalCarrouselVisible, setModalCarrouselVisible] = useState(false);

  const handleOpenImageBigSize = (index: number) => {
    setCurrentImageCarroseulIndex(index);
    setModalCarrouselVisible(true);
  };
  const handleCloseImageBigSize = () => {
    setModalCarrouselVisible(false);
    setTimeout(() => {
      setCurrentImageCarroseulIndex(-1);
    }, 300);
  };

  useEffect(() => {
    document.body.style.overflow = visible ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [visible]);

  useEffect(() => {
    if (modalCarrouselVisible) {
      document.removeEventListener("keydown", onRequestClose, false);
    } else {
      document.addEventListener("keydown", onRequestClose, false);
    }

    return () => {
      document.removeEventListener("keydown", onRequestClose, false);
    };
  }, [modalCarrouselVisible]);

  return (
    <div>
      <ModalAnimation
        visible={visible}
        onClose={() => {
          document.body.style.overflow = "auto";
        }}
      >
        <div className="flex flex-col">
          <div>
            <button
              onClick={onRequestClose}
              className="p-2 mx-8 my-2 hover:shadow-lg-simple bg-white rounded-full border"
            >
              <ArrowPrev className="w-8 h-8 text-gray-700" />
            </button>
          </div>
        </div>
        <div className="overflow-y-auto h-screen">
          <div className="flex mx-16">
            <div className="grid grid-cols-1 md:grid-cols-2 w-full gap-4 mx-auto pt-8 pb-16 max-w-(--breakpoint-lg)">
              {gallery.map((item, index) => {
                if (item.type === "video") {
                  return (
                    <div
                      key={index}
                      className="flex w-full hover:opacity-75 h-20-vh bg-black rounded-lg relative"
                    >
                      <button
                        className="absolute w-full h-full"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleOpenImageBigSize(index);
                        }}
                      ></button>
                      {!modalCarrouselVisible && (
                        <Video
                          src={item.src}
                          thumbnail={item.thumbnail}
                          className="rounded-lg"
                        />
                      )}
                    </div>
                  );
                }

                return (
                  <button
                    key={index}
                    className="w-full hover:opacity-75 relative h-20-vh"
                    onClick={() => handleOpenImageBigSize(index)}
                  >
                    <Image
                      src={item.src}
                      alt={item.alt || ""}
                      className="block h-full w-full rounded-lg object-cover object-center"
                      fill={true}
                      activeCache={true}
                    />
                    {item?.caption && (
                      <div className="absolute bottom-0 w-full bg-gray-800/50 px-4 py-2 text-white truncate rounded-b-lg">
                        <div className="max-h-12 overflow-hidden text-ellipsis">
                          {item?.caption}
                        </div>
                      </div>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
        <ModalBigPicture
          items={gallery}
          visible={modalCarrouselVisible}
          currentIndex={currentImageCarroseulIndex}
          onRequestClose={handleCloseImageBigSize}
        />
      </ModalAnimation>
    </div>
  );
};

export default ModalAllImages;
